































import { Component, Vue, Emit } from 'vue-property-decorator'
import { QueryExpressOrderList } from '@/api'
import { VTable } from '@/components/table'
import { TableHander } from '@/components/table'
import { PriceFormat } from '@/utils/tyepconvert'
import UpdateShippedDialogV2 from './UpdateShippedDialogV2.vue'

@Component({
  components: { VTable,UpdateShippedDialogV2 }
})
export default class ExpressDialog extends Vue {
  private show = false
  // 物流节点demo，根据实际情况调整。
  private data: Array<any> = [
  ]
  private expressInfo: any = {}
  private expressInfoList = []
  private activeName = '0'
  @Emit('close')
  private close() {
    this.show = false
  }

  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号',param:'id' , type: 'index' },
    // { title: '供应商', param: 'supplierCode' },
    { title: '商品图片', param: 'goodsMainImg' , width: 60 , type:'image' },
    { title: '商品编号', param: 'goodsCode' },
    { title: '商品名称', param: 'goodsName' },
    { title: 'SKU规格', param: 'skuSpecDesc' },
    { title: '商品数量', param: 'count' },
    { title: '发货数量', param: 'expressQty' },
    { title: '销售金额', param: 'price', formatter: PriceFormat },
    { title: '是否发货', param: 'expressCode', formatter: (e)=> e ? '发货':'未发货' },
    // { title: '活动时销售金额', param: 'activitySalesIntegral', formatter: PriceFormat },
  ]

  private orderCode: any = ""
  public async open( orderCode: string | null = null) {
    this.show = true
    this.orderCode = orderCode

    this.loadData()


  }

  private loadData(){
    if (this.orderCode) {
      // TODO 加载物流节点信息 需要更新接口
      const param = {
        orderCode:this.orderCode
      }
      QueryExpressOrderList(param).then(res=>{
        if(res){
          this.expressInfoList = res
          this.activeName = res[0].id
        }
      })
    }
  }

   private updateDeliveryOrder(item: any) {
    // 快递
    const d = this.$refs.UpdateShippedDialogV2 as UpdateShippedDialogV2
    d.open(item,this.orderCode)
  }

}
